import { MerchImagesList } from 'constants/icons';

const Footer = () => {
  return (
    <footer className="flex w-full mt-6 md:mt-0 justify-between md:justify-center gap-2 md:gap-8">
      {MerchImagesList.map((image) => (
        <img key={image.id} alt={image.alt} src={image.src} className="h-5 md:h-6" />
      ))}
    </footer>
  );
};

export { Footer };
